import get from "lodash/get";
import { TextSearchCriteria, MATCH } from "@/common/types/TextSearchCriteria";

export const textSearch = <T>(obj: T, criteria: TextSearchCriteria[]): boolean => {
  if (criteria.length === 0) {
    return true;
  }

  for (const criterion of criteria) {
    const text: string = get(obj, criterion.key) ?? "";

    switch (criterion.match) {
      case MATCH.PARTIAL:
        if (text.indexOf(criterion.text) === -1) {
          return false;
        }
        break;

      case MATCH.EXACT:
        if (text !== criterion.text) {
          return false;
        }
        break;

      case MATCH.FORWARD:
        if (!text.startsWith(criterion.text)) {
          return false;
        }
        break;

      case MATCH.BACKWARD:
        if (!text.endsWith(criterion.text)) {
          return false;
        }
        break;

      case MATCH.REGEXP:
        if (!new RegExp(criterion.text).test(text)) {
          return false;
        }
        break;

      default:
    }
  }

  return true;
};
